import "./resort-nearby-resorts.scss"
import "./static/no-webcam.svg"

export default function setListeners() {
  ;[...document.querySelectorAll(".resort-nearby-resorts a.elevation-mountain")].forEach(
    (button) => {
      button.addEventListener("click", (e) => {
        e.preventDefault()

        button.classList.add("is-loading")

        const { elev } = button.dataset
        const url = `${button.href}?elev=${elev}`
        fetch(url, { method: "GET" })
          .then((res) => res.text())
          .then((html) => {
            ;[...button.closest("ul").querySelectorAll(".elevation-mountain")].forEach((b) =>
              b.classList.remove("is-active"),
            )

            button.classList.remove("is-loading")
            button.classList.add("is-active")
            const tbody = button
              .closest(".resort-nearby-resorts")
              .querySelector(".resort-nearby-resorts-container")
            tbody.innerHTML = html

            if (window.currentUnits !== "Metric") {
              window.switchFCUnitsWithin(window.currentUnits, {
                container: tbody,
              })
            }
          })
      })
    },
  )
}
